// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  twonaBaseUrl: "https://pre-ams-api.twonas.com",
  loginApiBaseUri: "https://pre-login-api.twonas.com", // login backend url
  loginBaseUri: "https://pre-login.twonas.com", // login front url
  profileBaseUri: "https://pre-profile.twonas.com", // profile front url
  appBasePath: "/app",
  storageApiBaseUri: "https://pre-storage-api.twonas.com", // Files API base URL
  fileComparisonBaseUri: "https://pre-filecomparison.twonas.com", // file comparison app url
  accountsApiBaseUri: "https://pre-accounts-api.twonas.com", // Accounts API base URL
  services: {
    pusher: {
      key: "ddbc5d1d18940fb3610f",
      cluster: "eu"
    },
    sentry: {
      enabled: true,
      dsn: "https://f52aaf7a9bacf3ac28c94d45889f17b8@o113565.ingest.us.sentry.io/4510380024397824" // app-preproduction
    }
  }
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
